// extracted by mini-css-extract-plugin
export default {"postButton":"UserComponent_postButton__pGR-Y","buttonsCol":"UserComponent_buttonsCol__bbLrB"};